import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger } from "../lib/motion";

const PAINS = [
  "Your business grew. Your brand didn't.",
  "You're better than your website makes you look.",
  "You're getting attention. But not enough inquiries.",
];

export const IsItForMe = () => (
  <section className="relative py-24 lg:py-32 bg-[#0A0C0F]" data-testid="is-it-for-me-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }} variants={stagger}>
        <motion.p variants={fadeUp} className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] mb-6">
          / Is HughLaunch For You?
        </motion.p>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            {PAINS.map((p, i) => (
              <motion.p
                key={p}
                variants={fadeUp}
                data-testid={`pain-line-${i}`}
                className="border-t border-[#2A2D34] py-6 text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[1.02] text-white last:border-b"
              >
                {p.split(". ").map((part, j, arr) => (
                  <span key={j} className={j === arr.length - 1 && arr.length > 1 ? "text-[#C6FF00]" : ""}>
                    {part}{j < arr.length - 1 ? ". " : ""}
                  </span>
                ))}
              </motion.p>
            ))}
          </div>
          <motion.div variants={fadeUp} className="lg:col-span-5 lg:pl-6 lg:pt-6">
            <p className="text-lg text-[#8A939B] font-medium leading-relaxed">
              Sound familiar? HughLaunch is built for service businesses that are
              <span className="text-white"> genuinely good at what they do</span> — but
              their brand, website or client-acquisition system hasn't caught up yet.
            </p>
            <p className="mt-5 text-lg text-[#8A939B] font-medium leading-relaxed">
              If your work is better than your online presence suggests, the free
              Brand Audit will show you exactly where the gap is.
            </p>
            <Link
              to="/brand-audit"
              data-testid="is-it-for-me-audit-cta"
              className="btn-shine mt-8 inline-flex items-center gap-2 rounded-full bg-[#C6FF00] px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#0A0C0F] transition-colors duration-300 hover:bg-white lime-glow"
            >
              Get Your Free Brand Audit <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  </section>
);
